import React, { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../firebase";
import { getDatabase, ref, get, set } from "firebase/database";
import { toast } from "../toast";

const ArticleCreateForm = () => {
  const [user, setUser] = useState(null);

  const [category, setCategory] = useState("");  // Event Category
   const [SetPublic, SetArticlePublic] = useState("");  // Event Category
    const [SetImages, SetArticleImages] = useState("");  // Event Category


  // Define options for each category
//   const eventOptions = {
//     AUTOMOTIVE: [
//       { value: "RACE", label: "Race" },
//       { value: "RALLY", label: "Rally" },
//       { value: "DRAG", label: "Drag" },
//       { value: "DRIFT", label: "Drift" },
//       { value: "TRACKDAY", label: "Trackday" },
//       { value: "MEETUP", label: "Meetup" },
//       { value: "OTHER", label: "Other" },
//     ],
//     SPORTS: [
//       { value: "HOCKEY", label: "Hockey" },
//       { value: "FOOTBALL", label: "Football" },
//       { value: "BASKETBALL", label: "Basketball" },
//       { value: "SWIMMING", label: "Swimming" },
//       { value: "OTHER", label: "Other" },
//     ],
//   };

  // Handle category change
  const handleCategoryChange = (e) => {
    setCategory(e.target.value);
  };

  const handlePublicChange = (e) => {
    SetArticlePublic(e.target.value);
  };

    const handleImagesChange = (e) => {
    SetArticleImages(e.target.value);
  };

  useEffect(() => {
    // Check for Bootstrap availability
    if (!window.bootstrap) {
      console.error("Bootstrap JS not loaded. Ensure the CDN is included in index.html.");
    }

    // Firebase Auth listener
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    return () => unsubscribe();
  }, []);


  const handleSaveEvent = () => {
    const database = getDatabase();

    onAuthStateChanged(auth, async (user) => {
      if (!user) return;

      const uid = user.uid;
      const userRef = ref(database, "USERS/" + uid);

      try {
        const snapshot = await get(userRef);

        const userData = snapshot.val();

        const EVENT_OWNERDISPLAY = userData.USERDISPLAYNAME || "Unknown";

        const articleTitle = document.getElementById("ArticleTitle")?.value;

        const NEWS_EVENTSLUG = document.getElementById("NEWS_EVENTSLUG")?.value;
        
        const day = document.getElementById("EventDay")?.value;
        const month = document.getElementById("EventMonth")?.value;
        const year = document.getElementById("EventYear")?.value;


        // Collect event data
        const NEWS_ARTICLETITLE = articleTitle;
        const NEWS_ARTICLEDATE = day && month && year ? `${day}/${month}/${year}` : "";
        // const NEWS_ARTICLETYPE = EventType;
        // const NEWS_ARTICLELOCATION = EventLocation;
        // const NEWS_ARTICLEPOSTCODE = EventPostcode;
        const NEWS_ARTICLEFULLDESC = document.getElementById("NEWS_ARTICLEFULLDESC")?.value || "";
        const NEWS_ARTICLESHORTDESC = document.getElementById("NEWS_ARTICLESHORTDESC")?.value || "";


        const NEWS_ARTICLEFULLDESC2 = document.getElementById("NEWS_ARTICLEFULLDESC2")?.value || "";


        const NEWS_ARTICLETAGS = document.getElementById("NEWS_ARTICLETAGS")?.value || "";


        const NEWS_ARTICLELOCATIONMAP = "";
        const NEWS_ARTICLEOWNER = uid;

        const SETCATEGORY = document.getElementById("NewsEventCategory")?.value || "AUTOMOTIVE";
        const NEWS_ARTICLEPUBLIC = document.getElementById("NewsArticlePublic")?.value || "N";
        const NEWS_ARTICLEIMAGES = document.getElementById("NewsArticleImages")?.value || "N";
        const NEWS_ARTICLEIMAGESAMOUNT = document.getElementById("NewsArticleImagesAmount")?.value || "0";

        const NEWS_PHOTOGRAPHERNAME1 = "";
        const NEWS_PHOTOGRAPHERNAME2 = "";

        const slugify = (text) => {
          return text
            .toLowerCase()                   // lowercase
            .normalize("NFD")                // normalize accented characters
            .replace(/[\u0300-\u036f]/g, "")// remove accents
            .replace(/[^a-z0-9]+/g, "-")    // replace non-alphanumeric with -
            .replace(/(^-|-$)/g, "");       // trim - from start/end
        };

        const NEWS_ARTICLESLUG = slugify(articleTitle);

        // Create unique ID
        const now = new Date();
        const RaceCreatetime = `NEWSID${now.getTime()}${Math.floor(Math.random() * 999999)}`;

        const eventData = {
          NEWS_ARTICLETITLE,
          NEWS_ARTICLEDATE: NEWS_ARTICLEDATE,
          NEWS_EVENTSLUG,
          NEWS_ARTICLELOCATION: NEWS_ARTICLELOCATIONMAP,
          NEWS_ARTICLEOWNER,
          NEWS_ARTICLEOWNERNAME: EVENT_OWNERDISPLAY,
          NEWS_ARTICLESHORTDESC,
          NEWS_ARTICLEFULLDESC,
          NEWS_ARTICLEFULLDESC2,
          NEWS_PHOTOGRAPHERNAME1,
          NEWS_PHOTOGRAPHERNAME2,
          NEWS_ARTICLEPUBLIC,
          SETCATEGORY,
          NEWS_ARTICLESLUG,
          NEWS_ARTICLETAGS,
          NEWS_ARTICLEIMAGES,
          NEWS_ARTICLEIMAGESAMOUNT
        };

        // Save to DB
        const eventPath = `NEWS/${RaceCreatetime}`;
        await set(ref(database, eventPath), eventData);

        // Hide modal and show success toast
        toast("Your event has been successfully created!", `https://attendiau.co.uk/news/${NEWS_ARTICLESLUG}`, "created");
      } catch (error) {
        // console.log(error);
        toast("Error creating Event. <br> Please Retry.", "#", "danger");
      }
    });
  };

  //   const handleClick = () => {
  //       toast("Event Created!", "success");
  //   };

  return (
    <div className="container my-5">

      {user && (
        <>

        <h1 className="mt-5 event-heading-start">Create New Article.</h1>
        <p className="event-sub-text mb-5"> Create and Post a news Article ( this will show on the home page and news page).</p>
                  
          
        <div className="row">
          <div className="col-md-6 mb-3">
                <label htmlFor="NewsEventCategory" className="form-label">News Event Category</label>
                <select
                className="form-select"
                id="NewsEventCategory"
                value={category}
                onChange={handleCategoryChange}
                >
                <option value="">Select</option>
                <option value="GENERAL">General</option>
                <option value="AUTOMOTIVE">Automotive</option>
                <option value="SPORTS">Sports</option>
                <option value="MUSIC">Music</option>
                </select>
            </div>
        </div>

        <div className="row">
          <div className="col-md-6 mb-3">
            <label htmlFor="ArticleTitle" className="form-label">
              Article Title 
            </label>
            <input type="text" className="form-control" id="ArticleTitle" />
          </div>
        </div>

         <div className="row mb-3">
          <div className="col-md-4">
            <label className="form-label">Event Date <span className="text-danger-small">Required</span></label>
            <div className="d-flex gap-2">
              <select className="form-select" id="EventDay">
                <option value="">Day</option>
                {[...Array(31)].map((_, i) => (
                  <option key={i + 1} value={String(i + 1).padStart(2, "0")}>{i + 1}</option>
                ))}
              </select>

              <select className="form-select" id="EventMonth">
                <option value="">Month</option>
                {["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"].map((m, i) => (
                  <option key={m} value={m}>{new Date(0, i).toLocaleString("en-GB", { month: "long" })}</option>
                ))}
              </select>

              <select className="form-select" id="EventYear">
                <option value="">Year</option>
                {Array.from({ length: 5 }, (_, i) => {
                  const year = new Date().getFullYear() + i;
                  return <option key={year} value={year}>{year}</option>;
                })}
              </select>
            </div>
          </div>
    
        </div>

        <div className="row ">
          <div className="col-12 mb-3">
            <label htmlFor="NEWS_ARTICLESHORTDESC" className="form-label">Short Desc</label>
            <textarea className="form-control" id="NEWS_ARTICLESHORTDESC" rows="4" placeholder="Type something here"></textarea>
          </div>
        </div>

        <div className="row ">
          <div className="col-12 mb-3">
            <label htmlFor="NEWS_ARTICLEFULLDESC" className="form-label">Full Article</label>
            <textarea className="form-control" id="NEWS_ARTICLEFULLDESC" rows="4" placeholder="Type something here"></textarea>
          </div>
        </div>

        <div className="row ">
          <div className="col-12 mb-3">
            <label htmlFor="NEWS_ARTICLEFULLDESC2" className="form-label">Full Article2</label>
            <textarea className="form-control" id="NEWS_ARTICLEFULLDESC2" rows="4" placeholder="Type something here"></textarea>
          </div>
        </div>

        <div className="row ">
          <div className="col-12 mb-3">
            <label htmlFor="NEWS_EVENTSLUG" className="form-label">Event URLs</label>
            <input className="form-control" id="NEWS_EVENTSLUG" rows="4" placeholder="Paste the url after the /"/>
          </div>
        </div>


        <div className="row ">
          <div className="col-12 mb-3">
            <label htmlFor="NEWS_ARTICLETAGS" className="form-label">Event Tags</label>
            <input className="form-control" id="NEWS_ARTICLETAGS" rows="4" placeholder="Paste the url after the /"/>
          </div>
        </div>


        <div className="row">
          <div className="col-md-6 mb-3">
                <label htmlFor="NewsArticlePublic" className="form-label">Make Article Public on create?</label>
                <select
                className="form-select"
                id="NewsArticlePublic"
                value={SetPublic}
                onChange={handlePublicChange}
                >
                <option value="N">No</option>
                <option value="Y">Yes</option>
                </select>
            </div>

          <div className="col-md-6 mb-3">
                <label htmlFor="NewsArticleImages" className="form-label">Images Included?</label>
                <select
                className="form-select"
                id="NewsArticleImages"
                value={SetImages}
                onChange={handleImagesChange}
                >
                <option value="N">No</option>
                <option value="Y">Yes</option>
                </select>
            </div>
        </div>

        <div className="row ">
          <div className="col-12 mb-3">
            <label htmlFor="NewsArticleImagesAmount" className="form-label">Number of Images</label>
            <input className="form-control" id="NewsArticleImagesAmount" rows="4" placeholder="Enter the number of images"/>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 mb-3 text-end">
            <button type="button" className="btn btn-primary mt-3" onClick={handleSaveEvent}>Create</button>
          </div>
        </div>
          
        </>
      )}

    </div>
  );
};

export default ArticleCreateForm;
